import { border } from '../../layout/theme/border'
import { shadow } from '../../layout/theme/shadow'
import { themeColor } from '../../layout/theme/color'
import { surface } from '../../layout/theme/semanticTokens'

/** White rounded surface with hairline border. Plain CSS keys: usable in sx and styled(). */
export const cardSurfaceSx = {
  backgroundColor: surface.white,
  border: `${border.thin} solid ${border.light}`,
  borderRadius: border.card.radius,
  boxShadow: shadow.card,
} as const

/** White surface for a form (Create/Edit with `component="div"`). */
export const formSurfaceSx = {
  ...cardSurfaceSx,
  'overflow': 'clip',
  '&& .MuiToolbar-root': {
    bgcolor: themeColor.slate05,
    borderTop: `${border.thin} solid ${border.light}`,
    borderBottom: 0,
    px: 3,
    py: 1.5,
    mb: 0,
    mt: 0,
    minHeight: 'auto',
    borderRadius: 0,
  },
  '&& .RaSaveButton-root, && .MuiToolbar-root .MuiButton-root': { ml: 0 },
} as const

/** Page content width; the outer margin comes from RaLayout-content. */
export const pageSx = {
  px: { xs: 2, sm: 0 },
  maxWidth: 1400,
  width: '100%',
  boxSizing: 'border-box',
} as const
